import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef, useId } from 'react';
import clsx from 'clsx';
import { CheckboxPrimitive } from '../../checkbox-primitive/checkbox-primitive.js';
import { Label } from '../../label/label.js';
import { srOnly } from '../../styles/composables.css.js';
import { icon, baseIconButton } from '../base-icon-button.module.css.js';
import * as toggleButton_css from './toggle-button.css.js';
import { input, label, toggleButton, size } from './toggle-button.css.js';

/**
 * When an icon has a toggle-able state (where clicking on the icon flips between an on and an off state), we use a toggle button that changes between two icon states to convey an on or off state.
 *
 * @see https://fpl.figma.design/components/buttons/toggle-button/
 */
const ToggleButton = forwardRef(({ onIcon, offIcon, mixedIcon, 'aria-label': label$1, variant = 'primary', size: size$1 = 'md', ...props }, ref) => {
    const id = useId();
    let icon$1 = offIcon;
    if (props.checked && !props.mixed)
        icon$1 = onIcon;
    else if (props.mixed && mixedIcon)
        icon$1 = mixedIcon;
    // note: listen for data-tooltip={undefined} so the tooltip can be overridden.
    // i.e. look for key presence (x in y) rather than truthiness (!!x)
    let dataTooltip = label$1;
    if ('data-tooltip' in props) {
        dataTooltip = props['data-tooltip'];
    }
    const dataTooltipType = props['data-tooltip-type'] || 'text';
    return (jsxs("span", { "data-fpl-component": "", "data-disabled": props.disabled ? true : undefined, className: clsx(baseIconButton, toggleButton, size[size$1]), children: [jsx(CheckboxPrimitive, { ...props, className: clsx(input, toggleButton_css[variant]), id: id, "data-tooltip": dataTooltip, "data-tooltip-type": dataTooltipType, ref: ref }), jsxs(Label, { htmlFor: id, className: label, children: [jsx("span", { className: srOnly, children: label$1 }), jsx("span", { "aria-hidden": true, className: icon, children: icon$1 })] })] }));
});
ToggleButton.displayName = 'ToggleButton';

export { ToggleButton };
//# sourceMappingURL=toggle-button.js.map
